export default __webpack_public_path__ + "static/media/payment_failed.91ed2309.png";